import React from 'react';
import { FINISHES } from '../../data/finishes';

function ProductGallery() {
  return (
    <section className="pt-[70px] pb-[90px] bg-cream-hi" id="gallery">
      <div className="max-w-[1180px] mx-auto px-6 md:px-8">
        <div className="text-center max-w-[600px] mx-auto mb-11">
          <h2 className="font-display text-[1.9rem] md:text-[2.2rem] font-bold text-navy-deep">
            One device. Four finishes.
          </h2>
          <p className="text-navy mt-3">
            Goldie V2 retrofits onto any existing shower valve — matched to the room, not just
            the spec sheet.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {FINISHES.map((finish) => (
            <div key={finish.id} className="bg-cream shadow-nu-out rounded-nu px-[18px] pt-[22px] pb-[26px] text-center">
              <img
                src={finish.image}
                alt={`Goldie shower controller in ${finish.label}`}
                className="w-full aspect-square object-cover rounded-[20px] shadow-nu-gallery-img"
                loading="lazy"
              />
              <div className="mt-4 font-semibold text-[0.98rem] text-navy-deep">
                <span className={`inline-block w-4 h-4 rounded-full mr-2 align-[-2px] ${finish.swatchClassName}`} />
                {finish.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProductGallery;
